import { Milliseconds } from '@iotv/iotv-v3-types'
import { roundDecimals } from '../TypeHelpers'

/**
 * The number of minutes and seconds from `tZeroMs` until now
 */
export const getDurationMinSecStr = (tZeroMs: number) => {
  const duration = Date.now() - tZeroMs
  return `${Math.floor(duration / Milliseconds.MINUTE)} min ${roundDecimals((duration % Milliseconds.MINUTE) / Milliseconds.SECOND, 2)} secs`
}

export const getDurationHourMinStr = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = Math.floor(totalMinutes % 60)
  let res = ''
  if (hours !== 0) {
    res += hours + ' hours '
  }
  if (minutes !== 0) {
    res += minutes + ' minutes'
  }

  if (res === '') {
    res
  }

  return res
}

/**
 * Duration in days, hours, minutes, and seconds
 */
export const getDurationHourMinSecObject = (durationMs: number): { d: number; h: number; m: number; s: number } => {
  const d = Math.floor(durationMs / Milliseconds.DAY)
  const h = Math.floor((durationMs % Milliseconds.DAY) / Milliseconds.HOUR)
  const m = Math.floor((durationMs % Milliseconds.HOUR) / Milliseconds.MINUTE)
  const s = Math.floor((durationMs % Milliseconds.MINUTE) / Milliseconds.SECOND)

  return { d, h, m, s }
}

/**
 * Duration in days, hours, minutes, and seconds
 *
 * @example
 * ```
 * 34m 10s
 * ```
 *
 * @example
 * ```
 * 1d 6h 18m 24s
 * ```
 *
 * @example
 * ```
 * 7d
 * ```
 *
 * @example
 * ```
 * 1d 3m
 * ```
 */
export const getDurationHourMinSecStr = (durationMs: number) => {
  let res: string = ''
  const { d, h, m, s } = getDurationHourMinSecObject(durationMs)

  d && (res += `${d}d `)
  h && (res += `${h}h `)
  m && (res += `${m}m `)
  s && (res += `${s}s `)
  return res
}
